$shm_hitalama_map_widget_float_notebook_preview $shm_hitalama_map_widget_float_notebook
	List $mol_view
		sub /
			^ items
	Item* $mol_view
		sub /
			<= Item_row* $mol_view
				sub /
					<= Widget_controls*
